<template lang="pug">
  #adminsuper
    BTabs.block(v-model="activeTab" positioned="is-centered" expanded @input="updateRoute(activeTab)")
      BTabItem(v-for="tab in tabs" :key="tab.label" :label="tab.label")
    RouterView
</template>

<script>
import { tabsMixin } from "@/mixins/tabsMixin";
import AdminSuperChallengeCenter from "@/views/AdminSuperChallengeCenter";
import AdminSuperMapsCenter from "@/views/AdminSuperMapsCenter";
import AdminSuperStatsReporting from "@/views/AdminSuperStatsReporting";
import AdminSuperMemberCenter from "@/views/AdminSuperMemberCenter";
import AdminSuperReporting from "@/views/AdminSuperReporting.vue";
import AdminSuperMobileSupport from "@/views/AdminSuperMobileSupport.vue";
import AdminSuperResellers from "@/views/AdminSuperResellers.vue";

export default {
  name: "AdminSuper",

  components: {
    AdminSuperChallengeCenter,
    AdminSuperMapsCenter,
    AdminSuperStatsReporting,
    AdminSuperMemberCenter,
    AdminSuperReporting,
    AdminSuperMobileSupport,
    AdminSuperResellers
  },

  mixins: [tabsMixin],

  data() {
    return {
      tabs: [
        {
          label: "PROGRAMS",
          routeName: "AdminSuperPrograms"
        },
        {
          label: "REPORTING",
          routeName: "AdminSuperReporting"
        },
        {
          label: "MEMBERS",
          routeName: "AdminSuperMemberCenter"
        },
        {
          label: "CHALLENGES",
          routeName: "AdminSuperChallengeCenter"
        },
        {
          label: "MAPS",
          routeName: "AdminSuperMapsCenter"
        },
        {
          label: "COMMUNICATIONS",
          routeName: "AdminSuperCommunications"
        },
        {
          label: "MOBILE APP",
          routeName: "AdminSuperMobileSupport"
        },
        {
          label: "RESELLERS",
          routeName: "AdminSuperResellers"
        },
        {
          label: "DOCUMENTS",
          routeName: "AdminSuperDocumentManager"
        }
      ]
    };
  }
};
</script>
